class SlideshowSection extends HTMLElement {
  constructor() {
    super();
    // 确保在当前元素内查找，避免选择到其他 slideshow section 的元素
    this.mainSlide = this.querySelector(".swiper-slideshow-main");

    if (!this.mainSlide) {
      console.warn("未找到 .swiper-slideshow-main 元素");
      return;
    }
    // 获取地区 Banner 开关，优先从当前元素获取，如果没有则从父元素获取
    const regionBannerValue = this.dataset.enableRegionBanner ||
                              this.closest('[data-enable-region-banner]')?.dataset.enableRegionBanner ||
                              'false';
    // Liquid 中 true 会输出为 "true" 字符串，false 会输出为空字符串
    this.enableRegionBanner = regionBannerValue === "true" || regionBannerValue === true;
    this.init();
  }

  init() {
    const _this = this;
    if (!this.mainSlide) {
      return;
    }

    if (this.enableRegionBanner) {
      this.initRegionBanner();
    } else {
      this.initSlideShow();
    }
  }

  async initRegionBanner() {
    // 先隐藏所有 slides，等接口返回后再显示
    this.hideAllSlides();

    try {
      const region = await this.getUserRegion();
      this.filterSlidesByRegion(region);
      this.initSlideShow();
    } catch (error) {
      console.warn("获取用户地区失败，显示默认 Banner:", error);
      this.filterSlidesByRegion("other");
      this.initSlideShow();
    }
  }

  hideAllSlides() {
    if (!this.mainSlide) {
      return;
    }
    const slides = this.mainSlide.querySelectorAll(".swiper-slide");
    slides.forEach((slide) => {
      slide.style.display = "none";
    });
  }

  async getUserRegion() {
    try {
      const response = await fetch("https://api.ip.sb/geoip/");
      if (!response.ok) {
        throw new Error("API 请求失败");
      }
      const data = await response.json();
      const countryCode = data.country_code || "";
      const continentCode = data.continent_code || "";

      // 欧洲国家代码列表
      const europeCountries = [
        "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR",
        "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK",
        "SI", "ES", "SE", "GB", "IS", "LI", "NO", "CH", "AL", "AD", "BY", "BA",
        "FO", "GI", "GG", "JE", "MC", "MD", "ME", "MK", "RU", "SM", "RS", "UA",
        "VA", "XK"
      ];

      // 澳洲国家代码
      const australiaCountries = ["AU", "NZ", "FJ", "PG", "SB", "VU", "NC", "PF"];

      if (europeCountries.includes(countryCode.toUpperCase())) {
        console.log("用户IP来自欧洲国家:", countryCode);
        return "europe";
      } else if (australiaCountries.includes(countryCode.toUpperCase())) {
        console.log("用户IP来自澳洲国家:", countryCode);
        return "australia";
      } else {
        console.log("用户IP其他国家:", countryCode);
        return "other";
      }
    } catch (error) {
      console.error("获取用户地区时出错:", error);
      return "other";
    }
  }

  filterSlidesByRegion(region) {
    if (!this.mainSlide) {
      return;
    }
    const slides = this.mainSlide.querySelectorAll(".swiper-slide");

    slides.forEach((slide) => {
      const regionImages = slide.querySelectorAll(".banner-image-region");

      if (regionImages.length === 0) {
        // 如果没有地区图片包装器，说明没有启用地区功能，跳过
        return;
      }

      let hasRegionImage = false;

      // 先隐藏所有地区的图片
      regionImages.forEach((imgWrapper) => {
        imgWrapper.style.display = "none";
      });

      // 显示对应地区的图片
      regionImages.forEach((imgWrapper) => {
        const imgRegion = imgWrapper.dataset.region;
        if (imgRegion === region) {
          imgWrapper.style.display = "";
          hasRegionImage = true;
        }
      });

      // 如果没有找到对应地区的图片，检查是否有默认图片（other）
      if (!hasRegionImage) {
        // 检查是否有默认图片（other）
        const hasOtherImage = Array.from(regionImages).some(
          (imgWrapper) => imgWrapper.dataset.region === "other"
        );

        if (hasOtherImage) {
          // 如果有默认图片，显示它
          regionImages.forEach((imgWrapper) => {
            if (imgWrapper.dataset.region === "other") {
              imgWrapper.style.display = "";
            }
          });
        } else {
          // 如果没有对应地区的图片，也没有默认图片，隐藏整个 slide
          slide.style.display = "none";
          return;
        }
      }

      // 如果找到了对应地区的图片或默认图片，显示整个 slide
      slide.style.display = "";
    });
  }

  initSlideShow() {
    if (!this.mainSlide) {
      return;
    }
    let autoplay = this.mainSlide?.dataset.autoplay === "true";
    const loop = this.mainSlide?.dataset.loop === "true";
    let autoPlaySpeed = this.mainSlide?.dataset.autoPlaySpeed
      ? this.mainSlide?.dataset.autoPlaySpeed
      : 3000;
    const effect = this.mainSlide?.dataset.effect
      ? this.mainSlide?.dataset.effect
      : "slide";
    const animation = this.mainSlide?.dataset.effect
      ? this.mainSlide?.dataset.animation
      : "default";
    const pauseOnMouseEnter =
      this.mainSlide?.dataset.pauseOnMouseEnter === "true";
    if (autoplay) {
      autoplay = { delay: autoPlaySpeed, pauseOnMouseEnter: pauseOnMouseEnter };
    }
    const _this = this;
    const base = {
      autoplay: autoplay,
      effect: effect,
      loop: loop,
      navigation: {
        // 在当前 slideshow-section 元素内查找，确保不会选择到其他 section 的元素
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        // 在当前 slideshow-section 元素内查找，确保不会选择到其他 section 的元素
        el: this.querySelector(".swiper-pagination"),
      },
      on: {
        init: function (sw) {
          _this.mainSlide?.querySelectorAll(".slide-video-1").forEach((video) => {
            _this.loadSlideVideo(video, false);
          });
        },
        slideChangeTransitionStart: function (sw) {
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            .querySelectorAll("motion-effect")
            .forEach(async (motion) => {
              await motion.initAnimate();
            });
        },
        slideChangeTransitionEnd: function () {
          _this.mainSlide?.querySelectorAll("video-local-slide").forEach((video) => {
            _this.loadSlideVideo(video, false);
          });
          const currentSlide = this.slides[this.activeIndex];
          currentSlide
            ?.querySelectorAll("motion-effect")
            .forEach(async (motion) => {
              motion.classList.remove("animate-delay"),
                await motion.initAnimateEffect();
            });
        },
      },
    };
    base.effect = effect;
    base.speed = 400;
    const swiper = new Swiper(this.mainSlide, base);
    return swiper;
  }

  loadSlideVideo(_this, lazy = false) {
    if (window.innerWidth > 787) {
      if (!lazy && _this.classList.contains("video-mobile")) {
        return;
      }
    } else {
      if (!lazy && _this.classList.contains("video-desktop")) {
        return;
      }
    }
    if (!_this.getAttribute("loaded") && _this.querySelector("template")) {
      const content = document.createElement("div");
      content.appendChild(
        _this
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      _this.setAttribute("loaded", true);
      const deferredElement = _this.appendChild(content.querySelector("video"));
      const alt = deferredElement.getAttribute("alt");
      const img = deferredElement.querySelector("img");
      const video = _this.querySelector("video");
      video.preload = "metadata";
      this.waitForFirstFrame(video).then(() => {
        // 使用 this.mainSlide 确保使用正确的 slideshow 元素
        if (this.mainSlide) {
          this.mainSlide.classList.add("is-ready");
        }
      });
      if (alt && img) {
        img.setAttribute("alt", alt);
      }
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
            if (isIntersecting && intersectionRatio > 0.2) {
              const p = video.play();
              if (p && typeof p.catch === "function") {
                p.catch((err) => {
                  if (err?.name !== "AbortError")
                    console.warn("play failed:", err);
                });
              }
            } else {
              target.pause();
            }
          });
        },
        { threshold: [0, 0.2, 1] }
      );
      io.observe(video);
    }
  }

  waitForFirstFrame(video) {
    return new Promise((resolve) => {
      const done = () => {
        cleanup();
        resolve();
      };
      const cleanup = () => {
        video.removeEventListener("loadeddata", done);
        video.removeEventListener("playing", done);
        video.removeEventListener("timeupdate", onTime);
      };
      const onTime = () => {
        if (video.currentTime > 0) done();
      };

      if (
        (video.readyState >= 2 && video.videoWidth) ||
        video.currentTime > 0
      ) {
        return resolve();
      }
      video.addEventListener("loadeddata", done, { once: true });
      video.addEventListener("playing", done, { once: true });
      video.addEventListener("timeupdate", onTime, { once: true });

      if ("requestVideoFrameCallback" in video) {
        video.requestVideoFrameCallback(() => {
          done();
        });
      }
    });
  }
}
if (!customElements.get("slideshow-section")) {
  customElements.define("slideshow-section", SlideshowSection);
}
